<template>
  <el-dialog title="修改" :close-on-click-modal="false" :visible.sync="visible"
    @closed="reset">
    <el-form :model="dataForm" :rules="dataRule" ref="dataForm" label-width="auto">
        <el-form-item label="ID" :label-width="formLabelWidth" prop="id">
          <el-input v-model="dataForm.id" disabled autocomplete="off" />
        </el-form-item>
        <el-form-item label="服务器编号" :label-width="formLabelWidth" prop="host_id">
          <el-input v-model="dataForm.host_id" disabled autocomplete="off" />
        </el-form-item>
        <el-form-item label="服务器IP" :label-width="formLabelWidth" prop="hostname">
          <el-input v-model="dataForm.hostname" disabled autocomplete="off" />
        </el-form-item>
        <el-form-item label="远程账户" :label-width="formLabelWidth" prop="username">
          <el-input v-model="dataForm.username" disabled autocomplete="off" />
        </el-form-item>
        <el-form-item label="用户密码" :label-width="formLabelWidth" prop="password">
          <el-input v-model="dataForm.password" autocomplete="off" />
        </el-form-item>
        <el-form-item label="状态" :label-width="formLabelWidth" prop="is_lock">
          <el-radio-group v-model="dataForm.is_lock">
            <el-radio :label="0">正常</el-radio>
            <el-radio :label="1">锁定</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="备注" :label-width="formLabelWidth" prop="remark">
          <el-input v-model="dataForm.remark" autocomplete="off" />
        </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="visible = false">取消</el-button>
      <el-button type="primary" :loading="submitLoading" @click="dataFormSubmit">确定</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { eventBus } from '@containers/WinRD/utils/eventBus' // 全局事件总线

export default {
  data () {
    return {
      visible: false,
      submitLoading: false,
      appTypeList: [],
      is_lock: [
        { id: 0, name: '正常' },
        { id: 1, name: '异常' },
      ],
      dataForm: {
        id: '',
        host_id: '',
        hostname: '',
        username: '',
        password: '',
        is_lock: 0,
        remark: '',
      },
      dataRule: {
        host_id: [{
          required: true,
          message: '请选择服务器',
          trigger: 'blur',
        }],
        username: [{
          required: true,
          message: '请输入远程账户名',
          trigger: 'blur',
        }],
      },
    }
  },
  methods: {
    init (row, appTypeList) {
      this.visible = true
      this.appTypeList = appTypeList

      this.$nextTick(() => {
        // 修复焦点在带校验的项按回车提交后，再次打开对话框，该项会带有校验提示的问题
        // 而 resetFields 仍然放在关闭对话框时执行，以避免下次打开时，带动画的控件（如checkbox）会闪现之前的结果
        this.$refs.dataForm.clearValidate()

        // 对dataForm的赋值，需要滞后，以免变成默认值，reset时出问题
        this.dataForm.id = row.id
        if (this.dataForm.id != null) {
          this.dataForm = {
            id: row.id,
            name: row.name,
            host_id: row.host_id,
            hostname: row.hostname,
            username: row.username,
            password: row.password,
            is_lock: row.is_lock,
            remark: row.remark,
          }
        }
      })
    },
    reset () {
      this.$refs.dataForm.resetFields()
    },

    // 表单提交
    async dataFormSubmit () {
      this.$refs.dataForm.validate((valid) => {
        if (valid) {
          this.submitLoading = true
          const tmp = { ...this.dataForm }

          this.$http.post('/rdbackend/change_user', tmp, {
            headers: {
              'Content-Type': 'application/json',
            },
          }).then(response => {
            this.visible = false
            this.submitLoading = false
            this.$message({
              message: response.data.message,
              type: 'success',
              duration: 1500,
            })
            // 触发事件
            eventBus.$emit('refresh-list')
          }).catch(error => {
            this.$message({
              message: error.response.data.error,
              type: 'error',
              duration: 1500,
            })
            this.submitLoading = false
          })
        }
      })
    },
  },
}
</script>
